import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {  faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";
import {  faEnvelope } from "@fortawesome/free-solid-svg-icons";
function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const accessKey = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY || "";

    if (!accessKey) {
      alert("Missing Web3Forms access key. Please set REACT_APP_WEB3FORMS_ACCESS_KEY.");
      return;
    }

    fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        access_key: accessKey,
        ...formData
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          alert("Message sent! We'll get back to you soon.");
          setFormData({ name: "", email: "", message: "" });
        } else {
          alert("Error sending message. Please try again.");
        }
      })
      .catch((error) => alert(error));
  };

  return (
    <>
      <section className="hero half">
        <div className="hero-body">
          <section className="section has-text-centered social">
            <a title="facebook" href="https://facebook.com/saturnusclub">
              <FontAwesomeIcon icon={faFacebook} className="socialiconfooter is-size-4 has-text-primary"/>
            </a>
            <a title="instagram" href="https://www.instagram.com/saturnusclub">
              <FontAwesomeIcon icon={faInstagram} className="socialiconfooter is-size-4 has-text-primary"/>
            </a>
            <a href="mailto:support@saturnus.club">
              <FontAwesomeIcon icon={faEnvelope} className="socialiconfooter is-size-4 has-text-primary"/>
            </a>
          </section>

          <div className=" has-text-centered is-block is-quarterscreen">
            <div className="container">
              <div className="content">
                <div className="section">
                  <div className="columns">
                    <div className="column has-text-centered has-text-primary">
                      <form
                        name="contact"
                        method="post"
                        action="#"
                        onSubmit={handleSubmit}
                        className="contactinput"
                      >
                        <div className="field">
                          <label className="label has-text-primary" htmlFor="name">
                            Name
                          </label>
                          <div className="control">
                            <input
                              className="input contactinput"
                              type="text"
                              name="name"
                              onChange={handleChange}
                              id="name"
                              required
                            />
                          </div>
                        </div>
                        <div className="field">
                          <label className="label has-text-warning" htmlFor="email">
                            Email
                          </label>
                          <div className="control">
                            <input
                              className="input contactinput"
                              type="email"
                              name="email"
                              onChange={handleChange}
                              id="email"
                              required
                            />
                          </div>
                        </div>
                        <div className="field">
                          <label className="label has-text-primary" htmlFor="message">
                            Message
                          </label>
                          <div className="control">
                            <textarea
                              className="textarea contactinput"
                              name="message"
                              onChange={handleChange}
                              id="message"
                              required
                            />
                          </div>
                        </div>
                        <div className="field">
                          <button 
                            className="button is-fullwidth" 
                            type="submit"
                            style={{
                              padding: '0.75rem 1.5rem',
                              borderRadius: '8px',
                              fontWeight: '600',
                              letterSpacing: '0.5px',
                              fontSize: '1rem',
                              transition: 'all 0.2s cubic-bezier(.4,2,.3,1)',
                              border: '2px solid #FFA500',
                              background: 'linear-gradient(90deg, #FFA500 0%, #FFD700 100%)',
                              color: '#191919',
                              textTransform: 'uppercase',
                              boxShadow: '0 0 3px 0 #FFD70022',
                              cursor: 'pointer'
                            }}
                            onMouseEnter={e => {
                              e.target.style.boxShadow = '0 0 6px 0 #FFD70022';
                              e.target.style.filter = 'brightness(1.03)';
                              e.target.style.transform = 'scale(1.005)';
                            }}
                            onMouseLeave={e => {
                              e.target.style.boxShadow = '0 0 3px 0 #FFD70022';
                              e.target.style.filter = 'none';
                              e.target.style.transform = 'scale(1)';
                            }}
                          >
                            Send Message
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactForm;
